<div class="main_content px-3 position-relative">

    <div class="container-fluid">

        <div class="title mb-2">
            <h2 class="base_url">{{ current_module }} URL
                <span class="right_box">
                    <!-- <a href="{{ currentOrigin }}" target="_blank"><i class="fa-solid fa-square-up-right"></i></a> -->
                    <font data-toggle="modal" data-target="#myModal" (click)="openQrModal(parent)">
                      

                            <qrcode #parent [qrdata]="currentOrigin" cssClass="bshadow" [errorCorrectionLevel]="'M'"></qrcode>
                    </font>

                    <!-- <button  (click)="saveAsImage(parent)"></button> -->

                </span>
            </h2>
            <!-- <a href="">Click here to open customer feedback page</a> -->
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 ">
                <div class="white_box shadow p-3">
                    <p class="skip">Skip <input type="checkbox" (change)="skipFeedback($event.target.checked)" [(ngModel)]="isSkip"></p>

                    <app-feedbacks-card></app-feedbacks-card>

                </div>
            </div>
        </div>

        <div class="title mb-2">
            <h2 class="base_url review_list">{{ current_module }} REVIEWS
            </h2>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 ">
                <app-new-reviews></app-new-reviews>
            </div>
        </div>

    </div>
</div>

<div class="modal fade model_bar" id="myModal" role="dialog">
    <div class="modal-dialog modal-xs">
        <div class="modal-content">
            <!-- <div class="modal-header">
                <button type="button" #closebutton class="close" data-dismiss="modal">&times;</button>
                <h4 class="modal-title">Modal Header</h4>
            </div> -->
            <div class="modal-body">
                <div class="col-xl-12 mx-auto col-lg-12 col-md-12 mb-4">
                    <div class="card pt-3 text-center">
                        <h3>SCAN QR CODE</h3>
                        <br>
                        
                        <div
                            class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                            <img loading="lazy" src="{{ modalImg }}" alt="">
                        </div>
                        <!-- <p class="snatcoin">VIP tokens</p>
                        <p class="setprice">$ 100</p>

                        <span class="save_info bg-transparent" >
                        </span>

                        <span class="save_info" >
                            SAVE 10%
                        </span> -->

                        <br>

                        <!-- <a class="yellow_btn mx-auto my-3 " href="{{currentOrigin}}" target="_blank">Open Link</a> -->
                        <a class="yellow_btn mx-auto my-3" (click)="open_qr_link()">Open Link</a>
                        <a class="yellow_btn mx-auto my-3 " (click)="saveAsImage(parent)">Download QR Code</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>